<template>
  <div class="info-two">
    <van-cell-group title="工作资料">
      <err-tip domId="work_state" :errmsg="errMsg.work_state">
        <van-field
          v-model="form.work_state"
          label="工作状况"
          @click="showSheet = true"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          input-align="right"
        />
      </err-tip>
      <err-tip v-if="form.work_state === '其它'" domId="work_state_other" :errmsg="errMsg.work_state_other">
        <van-field
          clearable
          type="textarea"
          rows="2"
          maxlength="100"
          autosize
          v-model="form.work_state_other"
          placeholder="请具体说明工作状况详情，100个字内"
          @input="this.errMsg.work_state_other = ''"
        />
      </err-tip>
      <err-tip v-if="showMasterMsg" domId="master_name" :errmsg="errMsg.master_name">
        <van-field
          v-model="form.master_name"
          label="雇主名称"
          input-align="right"
          maxlength="100"
          clearable
          placeholder="请输入"
          @input="this.errMsg.master_name = ''"
        />
      </err-tip>
      <err-tip v-if="showMasterMsg" domId="position" :errmsg="errMsg.position">
        <van-field
          v-model="form.position"
          label="职位"
          input-align="right"
          maxlength="100"
          clearable
          placeholder="请输入"
          @input="this.errMsg.position = ''"
        />
      </err-tip>
      <err-tip v-if="showMasterMsg" domId="industry" :errmsg="errMsg.industry">
        <van-field
          label-width="7em"
          v-model="form.industry"
          @click="showPopup = true"
          label="行业/业务性质"
          placeholder="请选择"
          input-align="right"
          right-icon="arrow"
          readonly
        />
      </err-tip>
      <err-tip v-if="showMasterMsg" domId="work_year" :errmsg="errMsg.work_year">
        <van-field
          v-model="form.work_year"
          label="受雇年期(年)"
          clearable
          maxlength="100"
          input-align="right"
          placeholder="请输入数值"
          :formatter="formatterWorkYear"
          @input="this.errMsg.work_year = ''"
        />
      </err-tip>
      <err-tip v-if="showMasterMsg" domId="office_tel" :errmsg="errMsg.office_tel">
        <van-field
          v-model="form.office_tel"
          input-align="right"
          maxlength="100"
          clearable
          label="办公电话"
          placeholder="请输入，格式如：+86-0755-22664061"
          :formatter="formatterOfficeTel"
          @input="this.errMsg.office_tel = ''"
        />
      </err-tip>
      <err-tip v-if="showMasterMsg" domId="office_addr" :errmsg="errMsg.office_addr">
        <van-field
          v-model="form.office_addr"
          label="办公地址"
          maxlength="100"
          clearable
          input-align="right"
          placeholder="请输入"
          @input="this.errMsg.office_addr = ''"
        />
      </err-tip>
    </van-cell-group>
    <van-cell-group title="财务资料">
      <err-tip domId="annual_salary" :errmsg="errMsg.annual_salary">
        <van-field
          clearable
          v-model="form.annual_salary"
          label="年薪 (港币)"
          maxlength="100"
          placeholder="请输入"
          input-align="right"
          type="number"
          :formatter="formatterFundZero"
          @input="this.errMsg.annual_salary = ''"
        />
      </err-tip>
      <err-tip domId="net_asset" :errmsg="errMsg.net_asset">
        <van-field
          label-width="7em"
          v-model="form.net_asset"
          clearable
          maxlength="100"
          input-align="right"
          label="资产净值(港币)"
          placeholder="请输入"
          type="number"
          :formatter="formatterFund"
          @input="this.errMsg.net_asset = ''"
        />
      </err-tip>
      <err-tip domId="income_source" :errmsg="errMsg.income_source">
        <van-cell>
          <template #title>
            <span class="van-cell__title van-field__label">收入来源</span>
          </template>
          <template #extra>
            <van-checkbox-group class="check-group" v-model="form.income_source" @change="this.errMsg.income_source = '';">
              <van-checkbox name="薪金" shape="square">薪金</van-checkbox>
              <van-checkbox name="储蓄" shape="square">储蓄</van-checkbox>
              <van-checkbox name="租金" shape="square">租金</van-checkbox>
              <van-checkbox name="其它" shape="square">其它</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-cell>
      </err-tip>
      <err-tip v-if="showOtherIncome" domId="other_income" :errmsg="errMsg.other_income">
        <van-field
          clearable
          v-model="form.other_income"
          label="其它收入来源"
          input-align="right"
          maxlength="100"
          placeholder="请输入"
          @input="this.errMsg.other_income = ''"
        />
      </err-tip>
    </van-cell-group>
    <van-action-sheet
      v-model:show="showSheet"
      :actions="work_state"
      @select="onSheetSelect"
      maxlength="100"
      cancel-text="取消"
      close-on-click-action
    />
    <van-popup position="bottom" v-model:show="showPopup">
      <van-picker
        :columns="industry"
        @confirm="onPopupSelect"
        @cancel="showPopup = false"
      />
    </van-popup>
    <div style="width: 100%;text-align: center;">
      <van-button type="primary" class="btn" @click="next">
        下一步(投资目标及经验)
      </van-button>
      <van-button class="btn" @click="before">
        上一步
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  Button,
  CellGroup,
  Field,
  ActionSheet,
  Popup,
  Picker,
  Cell,
  Checkbox,
  CheckboxGroup,
  NumberKeyboard,
} from 'vant';
import { useStore } from 'vuex';
import {
  onMounted, watch, reactive, ref,
} from 'vue';
import httpApi from '../../utils/httpApi';
import ErrTip from '../ErrTip.vue';

const work_state = [{ name: '受雇' }, { name: '自雇' }, { name: '家庭主妇' }, { name: '退休' }, { name: '其它' }];
const industry = [
  '能源',
  '化工',
  '材料',
  '机械设备/军工',
  '企业服务',
  '造纸印刷',
  '运输设备',
  '旅游酒店',
  '媒体/信息通信服务',
  '批发/零售',
  '消费品',
  '卫生保健/医疗',
  '金融',
  '建材/建筑/房地产',
  '公用事业',
];
let submitForm = {};
export default {
  name: 'Home',
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [NumberKeyboard.name]: NumberKeyboard,
    ErrTip,
  },
  data() {
    return {
      work_state,
      industry,
      errMsg: {
        work_state: '',
        work_state_other: '',
        master_name: '',
        position: '',
        industry: '',
        work_year: '',
        office_tel: '',
        office_addr: '',
        annual_salary: '',
        net_asset: '',
        income_source: '',
        other_income: '',
      },
    };
  },
  methods: {
    formatterWorkYear(value) {
      const n = value.replace(/[^0-9]+/g, '').substr(0, 2);
      return Number(n) > 0 ? n : '';
    },
    formatterOfficeTel(value) {
      return value.replace(/[^0-9+-]+/g, '').substr(0, 20);
    },
    formatterFundZero(value) {
      const n = value.replace(/[^0-9]+/g, '').substr(0, 12);
      return Number(n) >= 0 ? n : '';
    },
    formatterFund(value) {
      const n = value.replace(/[^0-9]+/g, '').substr(0, 12);
      return Number(n) > 0 ? n : '';
    },
    async next() {
      const errData = { ...this.errMsg };
      Object.keys(errData).forEach(key => {
        errData[key] = '';
      });
      const requiredFields = [
        'work_state',
        'annual_salary',
        'net_asset',
        'income_source'
      ];
      requiredFields.forEach(field => {
        if (!submitForm[field] || (Array.isArray(submitForm[field]) && submitForm[field].length === 0)) {
          errData[field] = '请输入';
        }
      });
      if (submitForm.work_state === '其它') {
        if (!submitForm.work_state_other || !submitForm.work_state_other.trim()) {
          errData.work_state_other = '请输入具体工作状况';
        }
      }
      const work_type = ['受雇', '自雇'];
      if (work_type.includes(submitForm.work_state)) {
        const masterFields = [
          'master_name',
          'position',
          'industry',
          'work_year',
          'office_tel',
          'office_addr'
        ];
        masterFields.forEach(field => {
          if (!submitForm[field] || !submitForm[field].toString().trim()) {
            errData[field] = '请输入';
          }
        });
        if (submitForm.work_year && (!/^\d+$/.test(submitForm.work_year) || Number(submitForm.work_year) <= 0)) {
          errData.work_year = '请输入有效的工作年限';
        }
      }
      if (submitForm.income_source && submitForm.income_source.includes('其它')) {
        if (!submitForm.other_income || !submitForm.other_income.trim()) {
          errData.other_income = '请输入其它收入来源';
        }
      }
      const errorKeys = Object.keys(errData).filter(key => errData[key]);
      if (errorKeys.length > 0) {
        const firstErrorKey = errorKeys[0];
        const targetEle = document.getElementById(firstErrorKey);
        if (targetEle) {
          let scrollY = 0;
          document.querySelectorAll('*').forEach((el) => {
            if (el.scrollTop > 0) scrollY = el.scrollTop;
          });
          const offsetTop = targetEle.getBoundingClientRect().top + scrollY - 200;
          document.getElementById('app').scrollTo({ top: offsetTop, behavior: 'instant' });
        }
        this.errMsg = errData;
        return;
      }
      const { code, msg } = await this.$api.postInfoStepTwo(submitForm);
      if (code === 200) {
        this.$router.push({ path: '/info/step_three' });
      } else {
        this.$toast(msg);
      }
    },
    before() {
      this.$router.go(-1);
    },
    onNumberInput(value) {
      const oldValue = this.form[this.showNumberKeybord];
      if (oldValue) {
        this.form[this.showNumberKeybord] = oldValue + value;
      } else {
        this.form[this.showNumberKeybord] = value;
      }
    },
    onNumberDelete() {
      const value = this.form[this.showNumberKeybord];
      if (value) {
        this.form[this.showNumberKeybord] = value.substr(0, value.length - 1);
      }
    },
    onSheetSelect(value) {
      this.showSheet = false;
      this.form.work_state = value.name;
      this.errMsg.work_state = '';
    },
    onPopupSelect(value) {
      this.showPopup = false;
      this.form.industry = value;
      this.errMsg.industry = '';
    },
  },
  setup() {
    const form = reactive({
      work_state: '',
      work_state_other: '',
      master_name: '',
      position: '',
      industry: '',
      work_year: '',
      office_tel: '',
      office_addr: '',
      annual_salary: '',
      net_asset: '',
      income_source: [],
      other_income: '',
    });
    const showSheet = ref(false);
    const showPopup = ref(false);
    const showOtherIncome = ref(false);
    const showMasterMsg = ref(false);
    onMounted(async () => {
      const store = useStore();
      store.commit('setTitleValue', '资料填写');
      store.commit('setStepsValue', ['填写资料(2/5)', '风险认知', '提交资料']);
      store.commit('setStepsActive', 0);
      const result = await httpApi.getInfoStepTwo();
      if (!result) return;
      Object.getOwnPropertyNames(form).forEach((item) => {
        if (result.data[item]) {
          form[item] = result.data[item];
        }
      });
    });
    watch(form, (val) => {
      submitForm = { ...val };
      showOtherIncome.value = submitForm.income_source && submitForm.income_source.includes('其它');
      if (!showOtherIncome.value) {
        submitForm.other_income = '';
      }
      const work_type = ['受雇', '自雇'];
      showMasterMsg.value = work_type.includes(submitForm.work_state);
      if (!showMasterMsg.value) {
        submitForm.master_name = '';
        submitForm.position = '';
        submitForm.industry = '';
        submitForm.work_year = '';
        submitForm.office_tel = '';
        submitForm.office_addr = '';
      }
      if (submitForm.work_state !== '其它') {
        submitForm.work_state_other = '';
      }
    });
    return {
      form,
      showSheet,
      showPopup,
      showOtherIncome,
      showMasterMsg,
    };
  },
};
</script>

<style lang="less">
  .info-two {
    text-align: left;
    .check-group {
      width: 200px;
      height: 60px;
      display: flex;
      justify-content: space-around;
      align-items: space-around;
      flex-wrap: wrap;
      & > div {
        flex-basis: 50%;
      }
    }
    .btn {
      width: 80%;
      margin: @space-0 auto;
      margin-bottom: 0;
    }
  }
</style>
